import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Grid,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
  Card,
  CardContent,
  CardActions
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import MainLayout from '../../components/layouts/MainLayout';
import StorageService from '../../services/StorageService';
import AuthHttpService from '../../api/AuthHttpService';
import LoadingOverlay from '../../components/LoadingOverlay';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InsuranceModal from "../../components/InsuranceModal/InsuranceModal";
import UserHttpService from "../../api/UserHttpService";

function UserSettings() {
  const userData = StorageService.getAuth()?.user;
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [insurance, setInsurance] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      const auth = StorageService.getAuth();

      if (!auth?.token) {
        navigate('/');
        return;
      }

      try {
        await AuthHttpService.checkLoggedUser(auth.token);
        setIsAuthorized(true);
      } catch (error) {
        console.error('Auth check failed:', error);
        navigate('/');
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [navigate]);

  useEffect(() => {
    UserHttpService.getInsurance().then(data => {
      setInsurance(data.insurance)
    })
  })

  const handleBack = () => {
    navigate('/user-home');
  };

  const formatCPF = (cpf) => {
    if (!cpf) return '-';
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  };

  const formatCellphone = (phone) => {
    if (!phone) return '-';
    return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  };

  if (isLoading) {
    return <LoadingOverlay />;
  }

  return (
    <MainLayout>
      <Container>
        <Grid container spacing={3}>
          <Box sx={{mt: 10, display: 'flex', alignItems: 'center' }}>
            <Button
                startIcon={<ArrowBackIcon />}
                onClick={handleBack}
                sx={{ mr: 2 }}
            >
              Voltar
            </Button>
            <Typography variant="h4" component="h1">
              Configurações
            </Typography>
          </Box>


          <Grid item xs={12} mt={2}>
            <Paper elevation={3} sx={{ p: 3 }}>
              <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 5}}>
                <Typography variant="h5">
                  Plano
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<EditIcon />}
                    disabled={insurance === 36}
                    onClick={() => navigate('/update-insurance')}
                    sx={{
                      backgroundColor: "#FF6B00",
                      '&:hover': {
                        backgroundColor: "#e65100",
                      },
                    }}
                >
                  Editar Plano
                </Button>
              </div>
              <InsuranceModal insurance={insurance} />
            </Paper>
          </Grid>


          <Grid item xs={12} mt={2}>
            <Paper elevation={3} sx={{ p: 3 }}>
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                mb: 3
              }}>
                <Typography variant="h5">
                  Bem-vindo, {userData?.name || 'Usuário'}!
                </Typography>
                <Button
                  variant="contained"
                  startIcon={<EditIcon />}
                  onClick={() => navigate('/profile')}
                  sx={{
                    backgroundColor: "#FF6B00",
                    '&:hover': {
                      backgroundColor: "#e65100",
                    },
                  }}
                >
                  Editar Perfil
                </Button>
              </Box>

              <Typography variant="body1" paragraph>
                Esta é sua área pessoal. Aqui você pode visualizar suas informações e gerenciar sua conta.
              </Typography>

              <Box sx={{ mt: 3 }}>
                <Typography variant="h6" gutterBottom>
                  Suas Informações
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText
                      primary="Nome Completo"
                      secondary={userData?.name || '-'}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText
                      primary="CPF"
                      secondary={formatCPF(userData?.cpf)}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText
                      primary="Email"
                      secondary={userData?.email || '-'}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText
                      primary="Celular"
                      secondary={formatCellphone(userData?.phone)}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText
                      primary="Cidade"
                      secondary={userData.city || '-'}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText
                      primary="Estado"
                      secondary={userData.state || '-'}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText
                      primary="Cep"
                      secondary={userData.zipCode || '-'}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText
                      primary="Bairro"
                      secondary={userData.neighborhood || '-'}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText
                      primary="Rua"
                      secondary={userData.street || '-'}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText
                      primary="Numero"
                      secondary={userData.number || '-'}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText
                      primary="Complemento"
                      secondary={userData.complement || '-'}
                    />
                  </ListItem>
                </List>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </MainLayout>
  );
}

export default UserSettings;
